import {
  AHIcon,
  AHIconType,
  AHText,
  Box,
  ColorType,
  useLayoutContext,
  useTheme,
} from "arkh";
import React, { useMemo } from "react";
import { ActivityIndicator, Pressable, ViewStyle } from "react-native";

export function OrgButton({
  iconPostion = "right",
  ...props
}: {
  title: React.ReactNode;
  backgroundColor: ColorType;
  icon?: AHIconType;
  loading?: boolean;
  iconPostion?: "left" | "right";
  tintColor: ColorType;
  onPress?(): void;
  onPressIn?(): void;
  style?: ViewStyle;
  disabled?: boolean;
  border?: ColorType;
}) {
  const theme = useTheme();
  const layout = useLayoutContext();
  const backgroundColor = theme[props.backgroundColor];

  const Icon = useMemo(() => {
    if (props.loading) {
      return (
        <ActivityIndicator
          color={theme[props.tintColor]}
          size={"small"}
          style={{ transform: [{ scale: 0.7 }] }}
        />
      );
    }
    if (props.icon) {
      return (
        <Box
          // spaceLeft={iconPostion === "left" ? "xsmall" : "none"}
          // spaceRight={iconPostion === "right" ? "xsmall" : "none"}
          spaceHorizontal="xsmall"
          style={{ marginRight: -2, marginLeft: -2 }}
        >
          <AHIcon size="small" type={props.icon} color={props.tintColor} />
        </Box>
      );
    }
    return null;
  }, [props.icon, props.loading, props.tintColor, theme]);
  return (
    <Pressable
      style={({ pressed }) => [
        {
          borderRadius: 100,
          paddingHorizontal: layout.space.small,
          height: layout.circle.medium,
          backgroundColor,
          opacity: pressed || props.disabled ? 0.5 : 1,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          borderWidth: props.border !== undefined ? 1 : 0,
          borderColor: props.border ? theme[props.border] : undefined,
        },
        props.style,
      ]}
      disabled={props.disabled || props.loading}
      onPressIn={() => {
        props.onPressIn?.();
      }}
      onPress={() => {
        props.onPress?.();
      }}
    >
      {iconPostion === "left" ? Icon : null}
      <AHText
        type="subtitle"
        spaceHorizontal="xsmall"
        color={props.tintColor}
        selectable={false}
      >
        {props.title}
      </AHText>
      {iconPostion === "right" ? Icon : null}
    </Pressable>
  );
}
